export const MARKER_START = 'MARKER_START'